import { getEnv } from 'core_main/globals/env';
import { KNOWLEDGE_BASE_DOMAINS_ENDPOINT } from './constants';

export const makeGetKnowledgeBaseDomainsEndpoint = (
  knowledgeBaseId: string,
) => {
  return `/p/v1/kb/knowledge-bases/${knowledgeBaseId}/domains?domainStatus=ready` as typeof KNOWLEDGE_BASE_DOMAINS_ENDPOINT;
};

export const getHostDomain = () => {
  const { baseUrlDomain } = getEnv();
  if (baseUrlDomain?.includes('helpapp')) return 'helpapp';
  if (baseUrlDomain?.includes('helpsimply')) return 'helpsimply';
  return 'kustomer';
};

export const makeInternalKnowledgeBaseDomainName = () => {
  const { orgName } = getEnv();
  return `https://${orgName}.${getHostDomain()}.help`;
};
